export default __webpack_public_path__ + "static/media/46-4664562.47949b9c.png";